import { noop } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { CompactModal } from '@zocdoc-mezzanine/components-modal';
import {
    lazyImport,
    LazyComponent,
    LazySpinner,
} from '../../components/LazyImportComponent';

export const PhoneVerificationModal = (props) => {
    const [isContentLoaded, setContentLoaded] = useState(false);
    const getPhoneVerification = lazyImport(
        () =>
            import(
                /* webpackChunkName: "phone", webpackPrefetch: 30 */ './PhoneVerification'
            ),
        'PhoneVerification',
        () => setContentLoaded(true)
    );

    const PhoneVerification = getPhoneVerification();

    return (
        <CompactModal
            onClose={props.onClickCancelModal}
            hasContentLoaded={isContentLoaded}
            data-test="phone-verification-modal"
        >
            <LazyComponent
                componentName="PhoneVerification"
                fallback={
                    <Spacer>
                        <LazySpinner />
                    </Spacer>
                }
                onFailure={noop}
            >
                <PhoneVerification
                    data-test="phone-verification"
                    onComplete={props.onComplete}
                />
                <BottomSpacer />
            </LazyComponent>
        </CompactModal>
    );
};

const Spacer = styled.div`
    height: 200px;
    width: 100%;
`;

const BottomSpacer = styled.div`
    height: 16px;
    width: 100%;
    ${breakpoint.small} {
        display: none;
    }
`;
